import React from 'react'
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group'
import { AlertCircle } from 'lucide-react'

const SpecialLeviesSection = ({
  formData,
  errors,
  handleInputChange,
  isDark
}) => {
  if (formData.issueType !== 'minutes') return null

  return (
    <>
      <div className={`rounded-[16px] p-[20px] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
        isDark ? 'bg-[#292929] border-none shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)]' : 'bg-[#fff5eb] border-none shadow-[0px_0px_6px_1px_rgba(0,0,0,0.08)]'
      }`}>
        {formData.smata_config_id == 6 && (
          <div className="flex flex-col gap-[8px]">
            <span className={`font-medium text-[16px] transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#072837]'
            }`}>Any notes for Levy Team</span>
            <textarea
              className={`px-[12px] py-[10px] text-[16px] rounded-[8px] w-full transition-colors duration-200 outline-none resize-none ${
                isDark
                  ? 'bg-[#000000] text-white placeholder:text-[#b3b3b3] border-none focus:border-[#CD6D2C] focus:border-solid focus:border-[1px]'
                  : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa] text-[#072837] placeholder:text-[#686868] focus:border-[#CD6D2C]'
              }`}
              rows={3}
              placeholder="Optional notes for the levies team"
              value={formData.specialLeviesNotes || ''}
              onChange={(e) => handleInputChange('specialLeviesNotes', e.target.value)}
            />
          </div>
        )}
        <div>
          <span className={`font-medium text-[16px] transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}>{(formData.smata_config_id == 7 || formData.smata_config_id == 65) ? 'Were ordinary or special levies raised?' : 'Were special levies resolved?'} <span className="text-[#FF0000]">*</span></span>
          <RadioGroup
            className="flex flex-col gap-[12px] mt-[12px]"
            value={formData.specialLeviesResolved || ''}
            onValueChange={(v) => handleInputChange('specialLeviesResolved', v)}
            name="specialLeviesResolved"
          >
            <label className={`inline-flex items-center gap-[8px] text-[14px] transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#000]'
            }`}>
              <RadioGroupItem value="no" id="sl-no" />
              <span>No</span>
            </label>
            <label className={`inline-flex items-center gap-[8px] text-[14px] transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#000]'
            }`}>
              <RadioGroupItem value="yes" id="sl-yes" />
              <span>Yes</span>
            </label>
          </RadioGroup>
        </div>

        {formData.specialLeviesResolved === 'yes' && (
          <>
            <div className="flex flex-col gap-[8px]">
              <span className={`font-medium text-[16px] transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
              }`}>What Motion? <span className="text-[#FF0000]">*</span></span>
              <input
                className={`px-[12px] py-[10px] text-[16px] rounded-[8px] w-full transition-colors duration-200 outline-none ${
                  errors.specialLeviesMotion ? 'border-[1px] border-[#FF0000]' : ''
                } ${
                  isDark
                    ? 'bg-[#000000] text-white placeholder:text-[#b3b3b3] border-none focus:border-[#CD6D2C] focus:border-solid focus:border-[1px]'
                    : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa] text-[#072837] placeholder:text-[#686868] focus:border-[#CD6D2C]'
                }`}
                type="text"
                placeholder="Enter motion number(s)"
                value={formData.specialLeviesMotion || ''}
                onChange={(e) => handleInputChange('specialLeviesMotion', e.target.value)}
              />
            </div>
            {formData.smata_config_id != 6 && (
              <div className="flex flex-col gap-[8px]">
                <span className={`font-medium text-[16px] transition-colors duration-200 ${
                  isDark ? 'text-white' : 'text-[#072837]'
                }`}>Any notes for Levies Team</span>
                <textarea
                  className={`px-[12px] py-[10px] text-[16px] rounded-[8px] w-full transition-colors duration-200 outline-none resize-none ${
                    isDark
                      ? 'bg-[#000000] text-white placeholder:text-[#b3b3b3] border-none focus:border-[#CD6D2C] focus:border-solid focus:border-[1px]'
                      : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa] text-[#072837] placeholder:text-[#686868] focus:border-[#CD6D2C]'
                  }`}
                  rows={3}
                  placeholder="Optional notes for the levies team"
                  value={formData.specialLeviesNotes || ''}
                  onChange={(e) => handleInputChange('specialLeviesNotes', e.target.value)}
                />
              </div>
            )}
          </>
        )}
      </div>

      {errors.specialLeviesResolved && (
        <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
          <AlertCircle className="w-[16px] h-[16px] flex-shrink-0" />
          <span className="leading-[1.4]">Please select whether special levies were resolved.</span>
        </div>
      )}
      {!errors.specialLeviesResolved && errors.specialLeviesMotion && (
        <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
          <AlertCircle className="w-[16px] h-[16px] flex-shrink-0" />
          <span className="leading-[1.4]">Motion description is required when special levies were resolved.</span>
        </div>
      )}
    </>
  )
}

export default SpecialLeviesSection
